import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { isProductEnabled } from "@/business/product-access";
import { useGetBusiness } from "@/business/query";
import { useBusiness } from "@/core/business";
import {
  canAccessProfitability,
  canOpenProfitabilityReports,
} from "@/profitability/routes";
import { useGetMyUser } from "@/user/query";
import { ProfitabilityContent } from "./profitability-content";
import { ProfitabilityPreview } from "./profitability-preview";

const PageMessage = ({ children }: { children: string }) => (
  <Stack className="mx-auto max-w-[1680px] px-8 py-8" fullWidth>
    <Typography variant="bodyW1" textColor="secondary">
      {children}
    </Typography>
  </Stack>
);

const ProfitabilityPage = () => {
  const { businessId, isLoading } = useBusiness();
  const { data: user, isPending } = useGetMyUser();
  const {
    data: business,
    isLoading: isBusinessLoading,
    isError,
    isFetching,
    refetch,
  } = useGetBusiness(businessId);

  if (isPending || isLoading || isBusinessLoading)
    return <PageMessage>Loading…</PageMessage>;
  if (!businessId)
    return <PageMessage>Select a business to view its reports.</PageMessage>;

  if (isError || !business)
    return (
      <Stack className="mx-auto max-w-[1680px] px-8 py-8" fullWidth>
        <Typography variant="bodyW1" textColor="secondary">
          Business details could not load. Try again.
        </Typography>
        <Button onClick={() => refetch()} disabled={isFetching}>
          Try again
        </Button>
      </Stack>
    );

  if (canOpenProfitabilityReports(user, business))
    return <ProfitabilityContent key={businessId} businessId={businessId} />;

  if (
    isProductEnabled(business.enabled_products, "profitability") &&
    canAccessProfitability(user)
  )
    return <PageMessage>Reports are being set up.</PageMessage>;

  return <ProfitabilityPreview />;
};

export default ProfitabilityPage;
